module.exports = __webpack_public_path__ + "static/media/RationalPoojas.d127353b.jpg";